// extracted by mini-css-extract-plugin
export var base = "InformationBox-module--base--59101";
export var clearinformationbox = "InformationBox-module--clearinformationbox--6593d";
export var informationbox = "InformationBox-module--informationbox--c6f78";